/**
 * Small utility function used in conjunction with Formik to avoid showing errors when the field is empty
 */
export const handleChangeWithoutErrorWhenEmpty = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  fieldName: string,
  setFieldTouched: (
    field: string,
    isTouched?: boolean | undefined,
    shouldValidate?: boolean | undefined
  ) => void,
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
) => {
  if (!e.target.value) {
    setFieldTouched(fieldName, false);
  }
  handleChange(e);
};
